import React from 'react';
import PropTypes from 'prop-types';
import { xconnect } from '../../redux/xconnect';
import Uploader from '../common/Uploader';
import II18 from '../translate/II18';
import {
  setDocumentDataUrl,
  setDocumentPdfUploaded
} from '../../redux/actions/rootAction';
import { gae, gaeApp } from './Analytics';
import { handleSourcePdfLoaded } from '../../lib/pendingSourcePdfs';

export default function withDesktopUpload(WrappedComponent) {
  // noinspection JSPotentiallyInvalidUsageOfThis
  class withDesktopUploadWrapper extends React.Component {
    replaceDesktopImage = (docId, pageId, onLoadDone) => {
      return this.loadDesktopImage(docId, onLoadDone, pageId);
    };

    loadDesktopImage = (docId, onLoadDone, pageId) => {
      gaeApp('START_FILE_UPLOAD');
      const hasScannedPages = this.props.scannedDocuments.get(docId);
      Uploader.loadFromFile(
        !pageId,
        urls => {
          gae('DESKTOP_UPLOAD', 'ON_IMAGE_FROM_FILE_COMPLETE');
          if (pageId) {
            gaeApp('REPLACE_DOCUMENT_PAGE', pageId);
            this.props.setDocumentDataUrl(docId, pageId, urls[0]);
          } else {
            gaeApp('ADD_PAGES_TO_DOCUMENT');
            this.props.setDocumentDataUrl(docId, '', urls);
          }
          onLoadDone && onLoadDone(docId);
        },
        () => this.$f7.dialog.progress(II18.get('title_load'), 0),
        !(hasScannedPages && hasScannedPages.size) &&
          ((file, filesCount) => {
            handleSourcePdfLoaded({
              templateMode: this.props.templateMode,
              recipientRequestId: this.props.recipientRequestId,
              documentId: docId,
              file,
              filesCount,
              setDocumentPdfUploaded: this.props.setDocumentPdfUploaded,
              gaeCategory: 'DESKTOP_UPLOAD'
            });
          })
      );
    };

    getScannedPages(docId) {
      return (
        this.props.scannedDocuments && this.props.scannedDocuments.get(docId)
      );
    }

    render() {
      return (
        <WrappedComponent
          loadFromFile={this.loadDesktopImage}
          replaceDocumentPage={this.replaceDesktopImage}
          {...this.props}
        />
      );
    }
  }

  withDesktopUploadWrapper.propTypes = {
    scannedDocuments: PropTypes.object,
    setDocumentDataUrl: PropTypes.func,
    setDocumentPdfUploaded: PropTypes.func,
    recipientRequestId: PropTypes.string,
    templateMode: PropTypes.bool
  };

  const mapStateToProps = (state, ownProps) => {
    return {
      scannedDocuments: state.scannedDocuments,
      recipientRequestId: state.recipientRequestId,
      templateMode: state.templateMode
    };
  };

  const mapDispatchToProps = dispatch => ({
    setDocumentDataUrl: (documentId, pageId, dataUrl) =>
      dispatch(setDocumentDataUrl(documentId, pageId, dataUrl)),

    setDocumentPdfUploaded: (documentId, fileName) =>
      dispatch(setDocumentPdfUploaded(documentId, fileName))
  });

  return xconnect(
    mapStateToProps,
    mapDispatchToProps
  )(withDesktopUploadWrapper);
}
